import checkTypes from './checkTypes.js';
import appError from './appError.js';
import base64 from './base64.js';
import json from './json.js';

/**
 * Encode Base64 safely (supports IE10+ or IE6+ with base64 polyfill)
 * @param {object} decodedObject
 * @returns {string}
 */
export const encode = (decodedObject) => {
	checkTypes('aswparam.encode', {
		encodedString: [decodedObject, 'object']
	});
	try {
		const decodedString = JSON.stringify(decodedObject, json.circularReplacer());
		return base64.urlEncode(decodedString);
	} catch (error) {
		appError(error, {
			code: 'APP_SHARED_UTIL',
			origin: 'aswparam.encode',
			description: 'Decoded ASWPARAM string is not a valid JSON',
			detail: {
				decodedObject
			}
		});
		return '';
	}
};

/**
 * Decode Base64 safely (supports IE10+ or IE6+ with base64 polyfill)
 * @param {string} encodedString
 * @returns {object}
 */
export const decode = (encodedString) => {
	checkTypes('aswparam.decode', {
		encodedString: [encodedString, 'string']
	});
	if (!encodedString.length) {
		return {};
	}
	try {
		const decodedString = base64.urlDecode(encodedString);
		const nonPrintableReplacedString = decodedString.replace(/[\x7F-\x9F]/g, '');
		return JSON.parse(nonPrintableReplacedString);
	} catch (error) {
		appError(error, {
			code: 'APP_SHARED_UTIL',
			origin: 'aswparam.decode',
			description: 'Decoded ASWPARAM string is not a valid JSON',
			detail: {
				encodedString
			}
		});
		return {};
	}
};
